/**
 * Języki interfejsu i waluta, w której rozmawiamy z danym rynkiem.
 *
 * Waluta jest przypisana do JĘZYKA, nie do kraju — bo tyle wiemy o kimś, kto
 * właśnie wszedł na stronę. To przybliżenie i trzeba je znać: Austriak i Niemiec
 * dostaną euro (słusznie), ale Szwajcar piszący po niemiecku też — a płaci we
 * frankach. Dopóki nie pytamy o kraj, jest to najlepsze, co mamy; gdy zaczniemy
 * pytać, waluta ma iść za krajem, nie za językiem.
 */
export const LANGS = ["pl", "en", "de", "fr", "it", "es", "zh", "ja", "ko"];
export const CURRENCIES = ["PLN", "EUR", "USD", "CNY", "JPY", "KRW"];
/** Waluta, w której pokazujemy ceny mówiącemu tym językiem. */
export const CURRENCY_FOR_LANG = {
    pl: "PLN",
    de: "EUR",
    fr: "EUR",
    it: "EUR",
    es: "EUR",
    en: "USD",
    zh: "CNY",
    ja: "JPY",
    ko: "KRW",
};
/** Nazwa języka w nim samym — jedyna, którą jego użytkownik na pewno rozpozna. */
export const LANG_LABEL = {
    pl: "Polski",
    en: "English",
    de: "Deutsch",
    fr: "Français",
    it: "Italiano",
    es: "Español",
    zh: "中文",
    ja: "日本語",
    ko: "한국어",
};
/** Skrót do przełącznika w nagłówku, gdzie nie ma miejsca na pełną nazwę. */
export const LANG_SHORT = {
    pl: "PL", en: "EN", de: "DE", fr: "FR", it: "IT", es: "ES", zh: "中文", ja: "日本語", ko: "한국어",
};
/**
 * Języki w grupach — między grupami interfejs rysuje linię oddzielającą.
 *
 * Podział przebiega po piśmie, nie po zasięgu: pierwsza grupa to alfabet
 * łaciński, druga pismo wschodnioazjatyckie. Ma to znaczenie praktyczne —
 * pozycje CJK są węższe i inaczej się skanuje je wzrokiem, więc mieszanie ich
 * w jednej liście utrudnia znalezienie własnego języka.
 */
export const LANG_GROUPS = [
    ["pl", "en", "de", "fr", "it", "es"],
    ["zh", "ja", "ko"],
];
export function isLang(v) {
    return typeof v === "string" && LANGS.includes(v);
}
/**
 * Język z listy preferencji przeglądarki.
 *
 * Dopasowujemy po samym kodzie języka, bez regionu: `de-AT`, `de-CH` i `de`
 * mają dostać niemiecki. Brak dopasowania to polski, bo to język macierzysty
 * produktu, a nie angielski „bo międzynarodowy".
 */
export function pickLang(accepted, fallback = "pl") {
    for (const raw of accepted) {
        const kod = raw.trim().toLowerCase().split(/[-_]/)[0];
        if (isLang(kod))
            return kod;
    }
    return fallback;
}
//# sourceMappingURL=lang.js.map